import { Injectable } from '@angular/core';
import { UploadedFile } from '../interfaces/file-upload-interfaces';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecentUploadsService {
  private readonly STORAGE_KEY = 'recentUploads';

  private listOfRecentUploads: UploadedFile[] = [];

  // Cleanup
  public batchPipelineSub?: Subscription;
  public cancelAll$ = new Subject<void>();

  constructor() {
    this.listOfRecentUploads = this.loadFromLocalStorage();

    window.addEventListener('beforeunload', () => this.cleanup());
  }

  cleanup(): void {
    this.listOfRecentUploads.forEach(recentUpload => {
      if (recentUpload.currentUploadProgress !== 100) {
        recentUpload.canceled = true;
        recentUpload.currentUploadProgress = 100;
        recentUpload.uploadSubscription?.unsubscribe()
        recentUpload.uploadSubscription = null;
      }
    });

    this.cancelAll$.next();
    this.batchPipelineSub?.unsubscribe();
    this.batchPipelineSub = undefined;

    this.saveToLocalStorage();
  }

  private saveToLocalStorage() {
    var tempList = JSON.parse(JSON.stringify(this.listOfRecentUploads));

    tempList.forEach((upload: UploadedFile) => {
      if (upload.currentUploadProgress !== 100) {
        upload.currentUploadProgress = 100;
        upload.canceled = true;
        upload.uploadSubscription = null;
      }
    });

    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(tempList));
  }

  private loadFromLocalStorage(): UploadedFile[] {
    const data = localStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  }

  clearUploads(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    this.listOfRecentUploads = [];
  }

  addUpload(uploadedFile: UploadedFile) {
    return this.listOfRecentUploads.push(uploadedFile) - 1;
  }

  getUploads(): UploadedFile[] {
    return this.listOfRecentUploads;
  }

  getLastUploads(n: number): UploadedFile[] {
    return this.listOfRecentUploads.slice(-n);
  }

  getUploadByIndex(index: number): UploadedFile {
    return this.listOfRecentUploads[index];
  }

  setCanceled(index: number, canceled: boolean) {
    this.getUploadByIndex(index).canceled = canceled;
    this.getUploadByIndex(index).currentUploadProgress = (canceled) ? 100 : 0;
  }

  hasPendingUploads() {
    const hasPending = this.getUploads()
      .some(u => u.currentUploadProgress !== 100);

    return hasPending;
  }

  stopUpload(index: number) {
    const record = this.getUploadByIndex(index);
    if (!record) {
      return false;
    }

    if (record.uploadSubscription == null) {
      return false;
    }

    if (record.currentUploadProgress === 100) {
      return false;
    }

    record.uploadSubscription?.unsubscribe();
    record.uploadSubscription = null;

    this.setCanceled(index, true)
    return true;
  }
}
